import {
  Map2DControls,
  Map2DControlsRef,
} from "@faro-lotv/app-component-toolbox";
import { Camera } from "@react-three/fiber";
import { forwardRef, type JSX } from "react";

interface IProps {
  /** The camera to be moved by the controls */
  camera: Camera;
  /** Height of the plane we want to navigate to, used to compute the correct panning sensitivity */
  referencePlaneHeight?: number;
  /** True if the controls are enabled otherwise false  */
  enabled?: boolean;
}

/**
 * @returns Controls in sheet mode.
 */
export const SheetModeControls = forwardRef<Map2DControlsRef, IProps>(
  function SheetModeControls(
    { camera, referencePlaneHeight, enabled = true }: IProps,
    ref,
  ): JSX.Element {
    return (
      <Map2DControls
        camera={camera}
        referencePlaneHeight={referencePlaneHeight}
        enabled={enabled}
        ref={ref}
      />
    );
  },
);
